import { Text } from '@/components/ui/text'
import type { Tables } from '@hvf/contracts'

export default function (props: { setup?: Tables<'setup'>, textStyle?: string, fontSize?: string }) {

  if (!props.setup?.risk_reward_ratio) {
    <Text fontWeight='bold' color={'gray.10'}>unknown</Text>
  }

  return (
    <Text
      fontSize={props.fontSize || '17px'}
      fontWeight='600'
      letterSpacing='-.01em'
      color='editorialAccentDeep'
    >
      {props.setup?.risk_reward_ratio}
    </Text>
  )
}

